import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

export function NavSkeleton({ count = 5 }: { count?: number }) {
  return (
    <Box sx={{ px: 2 }}>
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} variant="rectangular" height={44} sx={{ mb: 0.5, borderRadius: 1 }} />
      ))}
    </Box>
  );
}
